import template from './success.modal.html';
import controller from './success.modal.controller';

let successModalComponent = {
  bindings: {
    onClosed: '&'
  },
  template,
  controller: controller
};

export default successModalComponent;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/bank-account/success.modal.component.js